import { Dialog, DialogContent, DialogTitle, Link, Typography } from '@mui/material';
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface EconsultReferralErrorDialogProps {
  isOpen: boolean;
}

const EconsultReferralErrorDialog: FC<EconsultReferralErrorDialogProps> = ({ isOpen }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      navigate(`/logout`);
    }, 20000);
  }, []);
  return (
    <Dialog
      open={isOpen}
      PaperProps={{
        sx: { width: 400, maxWidth: '90%' }
      }}>
      <DialogTitle>
        <Typography variant="h2" color="base.grey3">
          {t('Case.referral.error')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="base.grey3">
          <b>{t('Case.referral.authenticationTitle')}</b> - {t('Case.referral.authentication')}
        </Typography>
        <Typography variant="body2" color="base.grey3" mt={2}>
          {t('Case.referral.authentication2')}{' '}
          <Link href="mailto:contactupdates@otn.ca">contactupdates@otn.ca</Link>.
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default EconsultReferralErrorDialog;
